export default __webpack_public_path__ + "static/Quickinstallation_04-dea483517a202f7c9c4d4c1e99b023c6.webp";